import React from 'react'


const Curriculum = ({ CoursesDetails }) => {

    // Build audience details based on course title
    const getAudience = (title) => {
        const audienceMap = {
            'Technology & Future Trends': {
                heading: "Who it's for",
                intro: "Designed for forward‑thinking learners ready to understand and lead with emerging technologies.",
                audiences: [
                    "Professionals future‑proofing careers with technology literacy",
                    "Business leaders planning digital transformation",
                    "Entrepreneurs exploring tech‑driven opportunities",
                    "Students interested in AI, blockchain, IoT and next‑gen tech",
                    "Policy makers assessing technology’s social and economic impact"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Explain AI, blockchain, IoT, cloud and quantum in plain language",
                    "Evaluate opportunities and risks of new technologies",
                    "Map trends to business and public sector use‑cases",
                    "Create an actionable roadmap for adoption"
                ]
            },
            'Health & Wellbeing': {
                heading: "Who it's for",
                intro: "For people focused on improving personal and community health outcomes.",
                audiences: [
                    "Healthcare assistants, carers and wellbeing advocates",
                    "HR and People teams building wellbeing programs",
                    "Coaches and community workers supporting families",
                    "Students interested in public health and wellness"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Apply evidence‑based wellbeing practices",
                    "Design simple health and mental‑wellbeing routines",
                    "Support individuals with signposting to services",
                    "Promote healthy habits at work and home"
                ]
            },
            'Education & Career Growth': {
                heading: "Who it's for",
                intro: "For learners seeking clear pathways to academic and career advancement.",
                audiences: [
                    "Students and graduates planning next steps",
                    "Career‑changers developing marketable skills",
                    "Educators and mentors guiding learners",
                    "Jobseekers improving applications and interviews"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Build a targeted development plan",
                    "Showcase achievements with strong CVs and portfolios",
                    "Navigate hiring processes with confidence",
                    "Leverage lifelong learning strategies"
                ]
            },
            'Leadership & Personal Development': {
                heading: "Who it's for",
                intro: "For current and aspiring leaders building influence and self‑mastery.",
                audiences: [
                    "Team leaders and supervisors",
                    "Founders and small‑business owners",
                    "Professionals stepping into leadership roles",
                    "Community and project leaders"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Lead with clarity, empathy and accountability",
                    "Coach teams and run effective 1:1s",
                    "Resolve conflict and drive change",
                    "Create a personal growth system"
                ]
            },
            'Society, Arts & Culture': {
                heading: "Who it's for",
                intro: "For creatives and organisers working across culture and communities.",
                audiences: [
                    "Artists, writers and designers",
                    "Cultural project managers and curators",
                    "Teachers bringing arts into learning",
                    "Community organisers and facilitators"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Design engaging cultural programs",
                    "Collaborate with diverse communities",
                    "Fund and promote creative work",
                    "Document impact through stories and data"
                ]
            },
            'Environment & Sustainability': {
                heading: "Who it's for",
                intro: "For people advancing sustainability in organisations and communities.",
                audiences: [
                    "Sustainability coordinators and green teams",
                    "Facilities and operations professionals",
                    "Students of environmental science and policy",
                    "Citizens leading local climate action"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Measure footprint and identify reductions",
                    "Design circular and low‑waste practices",
                    "Engage stakeholders in climate initiatives",
                    "Report progress using clear metrics"
                ]
            },
            'Finance & Economy': {
                heading: "Who it's for",
                intro: "For people building financial capability and economic understanding.",
                audiences: [
                    "Early‑career professionals and founders",
                    "Community advisors and support workers",
                    "Students learning personal finance",
                    "Non‑financial managers owning budgets"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Create budgets and cash‑flow forecasts",
                    "Understand inflation, interest and risk",
                    "Read financial statements",
                    "Make informed saving and investment decisions"
                ]
            },
            'Future of Work & HR': {
                heading: "Who it's for",
                intro: "For HR, managers and practitioners building people‑centric workplaces.",
                audiences: [
                    "HR and People Operations",
                    "Line managers and team leads",
                    "Change managers and project leads",
                    "DEI champions and employee representatives"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Design hybrid work policies",
                    "Build skills frameworks and learning paths",
                    "Use data ethically for people decisions",
                    "Improve engagement and retention"
                ]
            },
            'Youth & Future Skills': {
                heading: "Who it's for",
                intro: "For young people and educators focused on essential future skills.",
                audiences: [
                    "Teenagers and college students",
                    "Youth workers and mentors",
                    "Early‑career jobseekers",
                    "Parents supporting career readiness"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Develop communication and problem‑solving",
                    "Use digital tools for learning and work",
                    "Create a standout early‑career portfolio",
                    "Plan pathways into growth sectors"
                ]
            },
            'Specialized Programs & Events': {
                heading: "Who it's for",
                intro: "For professionals running high‑impact programs, bootcamps and events.",
                audiences: [
                    "Program managers and coordinators",
                    "Corporate learning teams",
                    "Bootcamp and accelerator leads",
                    "Community and conference organisers"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Design outcomes‑driven programs",
                    "Market and recruit effectively",
                    "Run smooth operations and logistics",
                    "Measure impact and ROI"
                ]
            },
            'Law, Policy & Governance': {
                heading: "Who it's for",
                intro: "For those working at the intersection of law, public policy and governance.",
                audiences: [
                    "Public sector professionals",
                    "Advocates and policy researchers",
                    "Compliance and risk teams",
                    "Students of law and public administration"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Interpret policy and regulatory frameworks",
                    "Draft briefs and consultation responses",
                    "Balance rights, risk and innovation",
                    "Engage stakeholders transparently"
                ]
            },
            'Science & Research': {
                heading: "Who it's for",
                intro: "For aspiring researchers and practitioners using evidence to solve problems.",
                audiences: [
                    "Students entering research careers",
                    "Lab and field technicians",
                    "Data and insight analysts",
                    "Professionals adopting evidence‑based practice"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Frame questions and design studies",
                    "Collect and analyse qualitative and quantitative data",
                    "Report findings clearly",
                    "Apply ethics and reproducibility standards"
                ]
            },
            'Media & Digital Arts': {
                heading: "Who it's for",
                intro: "For creatives producing digital content and interactive media.",
                audiences: [
                    "Designers, editors and motion artists",
                    "Content creators and marketers",
                    "Educators teaching media production",
                    "Students building creative portfolios"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Plan and produce polished digital content",
                    "Use industry tools efficiently",
                    "Collaborate from concept to delivery",
                    "Publish and grow audiences"
                ]
            },
            'Lifestyle & Personal Growth': {
                heading: "Who it's for",
                intro: "For people building healthy, resilient and purposeful lives.",
                audiences: [
                    "Individuals seeking focus and balance",
                    "Coaches and mentors",
                    "HR and wellbeing champions",
                    "Students building positive habits"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Create routines for energy and focus",
                    "Set goals and track progress",
                    "Manage stress with practical tools",
                    "Build lifelong learning habits"
                ]
            },
            'Construction & Skilled Trades': {
                heading: "Who it's for",
                intro: "For people entering or progressing in hands‑on trades and construction.",
                audiences: [
                    "Apprentices and trainees",
                    "Site operatives and supervisors",
                    "Facilities and maintenance staff",
                    "Career‑changers moving into trades"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Apply safety, tools and measurement correctly",
                    "Read drawings and follow method statements",
                    "Work to quality standards",
                    "Communicate clearly on site"
                ]
            },
            'Transport & Logistics': {
                heading: "Who it's for",
                intro: "For professionals managing movement of people and goods.",
                audiences: [
                    "Warehouse, fleet and operations teams",
                    "Dispatch, scheduling and customer service",
                    "Planners and supply‑chain analysts",
                    "SMEs optimising last‑mile logistics"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Plan routes and capacity effectively",
                    "Use data to improve on‑time delivery",
                    "Manage health, safety and compliance",
                    "Coordinate suppliers and partners"
                ]
            },
            'Hospitality & Tourism': {
                heading: "Who it's for",
                intro: "For people delivering excellent guest and visitor experiences.",
                audiences: [
                    "Front‑of‑house and service teams",
                    "Event and venue staff",
                    "Tour operators and guides",
                    "New managers leading small teams"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Deliver consistent, memorable service",
                    "Handle complaints with confidence",
                    "Design guest journeys and experiences",
                    "Upsell ethically and increase loyalty"
                ]
            },
            'Beauty & Wellness': {
                heading: "Who it's for",
                intro: "For practitioners and enthusiasts in beauty, spa and holistic wellness.",
                audiences: [
                    "Beauty therapists and salon staff",
                    "Spa and wellness practitioners",
                    "Entrepreneurs starting services",
                    "Learners exploring professional pathways"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Apply hygiene and client‑care standards",
                    "Deliver safe, quality treatments",
                    "Recommend personalised routines",
                    "Build returning client relationships"
                ]
            },
            'Real Estate & Property Management': {
                heading: "Who it's for",
                intro: "For professionals managing, selling or investing in property.",
                audiences: [
                    "Lettings and property managers",
                    "Sales negotiators and assistants",
                    "Investors and landlords",
                    "Facilities and building operators"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Navigate lettings and sales processes",
                    "Manage maintenance and compliance",
                    "Communicate clearly with tenants and owners",
                    "Analyse investment opportunities"
                ]
            },
            'Arts, Media & Creativity': {
                heading: "Who it's for",
                intro: "For creative practitioners shaping ideas into compelling work.",
                audiences: [
                    "Artists and makers",
                    "Content creators and social media managers",
                    "Teachers integrating creativity into learning",
                    "Freelancers building a portfolio career"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Develop creative concepts and briefs",
                    "Produce and iterate work to deadline",
                    "Collaborate with clients and teams",
                    "Showcase work professionally"
                ]
            },
            'Food & Culinary Skills': {
                heading: "Who it's for",
                intro: "For aspiring chefs and food professionals.",
                audiences: [
                    "Kitchen assistants and commis chefs",
                    "Home cooks moving into hospitality",
                    "Caterers and street‑food traders",
                    "Students pursuing culinary arts"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Work safely and hygienically",
                    "Execute core techniques and prep",
                    "Plan menus and cost dishes",
                    "Plate and present professionally"
                ]
            },
            'Family & Parenting Support': {
                heading: "Who it's for",
                intro: "For carers and professionals supporting families and children.",
                audiences: [
                    "Parents and guardians",
                    "Early‑years and youth practitioners",
                    "Family support workers",
                    "Community volunteers"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Use positive communication techniques",
                    "Support learning and behaviour",
                    "Access relevant services and resources",
                    "Promote safe, nurturing environments"
                ]
            },
            'Sports & Fitness Training': {
                heading: "Who it's for",
                intro: "For those coaching or building personal fitness.",
                audiences: [
                    "Personal trainers and assistants",
                    "Sports coaches and community leaders",
                    "Athletes improving performance",
                    "Beginners establishing routines"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Program safe, progressive training",
                    "Coach technique and motivation",
                    "Track progress with simple metrics",
                    "Reduce injury risk and improve recovery"
                ]
            },
            'Technology & Digital Skills': {
                heading: "Who it's for",
                intro: "For anyone building practical digital skills for modern work.",
                audiences: [
                    "Jobseekers building digital confidence",
                    "Admins and coordinators",
                    "Entrepreneurs running online operations",
                    "Students preparing for tech‑enabled roles"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Use productivity and collaboration tools",
                    "Manage files, data and basic automation",
                    "Work safely online and protect privacy",
                    "Solve everyday tech problems"
                ]
            },
            'Business & Entrepreneurship': {
                heading: "Who it's for",
                intro: "For founders and self‑starters launching or growing a venture.",
                audiences: [
                    "Aspiring and early‑stage founders",
                    "Side‑hustlers validating ideas",
                    "Freelancers productising services",
                    "Community and social enterprise leaders"
                ],
                outcomesHeading: "After this course, you'll be able to",
                outcomes: [
                    "Validate problems and test solutions",
                    "Build simple business models and plans",
                    "Acquire first customers ethically",
                    "Manage finances and measure traction"
                ]
            }
        };

        return audienceMap[title] || {
            heading: "Who it's for",
            intro: "This course suits motivated learners seeking practical skills and real‑world outcomes.",
            audiences: [
                "Beginners aiming to build a solid foundation",
                "Professionals upskilling to advance their career",
                "Teams aligning on shared concepts and terminology"
            ],
            outcomesHeading: "After this course, you'll be able to",
            outcomes: [
                "Understand key concepts and best practices",
                "Apply learning to real scenarios",
                "Communicate effectively with peers and stakeholders"
            ]
        };
    };

    const data = getAudience(CoursesDetails?.title);

    return (
        <div className="wpo-course-content">
            <div className="wpo-course-text-top">
                <h2>{data.heading}</h2>
                <div className="course-b-text mt-1">
                    <p>{data.intro}</p>
                </div>
                <div className="course-curriculam">
                    <ul>
                        {data.audiences.map((item, i) => (
                            <li key={i}><span>{item}</span></li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="wpo-course-text-top">
                <h2>{data.outcomesHeading}</h2>
                <div className="course-curriculam">
                    <ul>
                        {data.outcomes.map((item, i) => (
                            <li key={i}><span>{item}</span></li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Curriculum;